import Loading from 'components/Loading/Loading';
import styled from 'styled-components';

const LoaderContainer = styled.div<{
  $minHeight: string;
  $marginBottom?: string;
  $padding?: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* gap: 24px; */

  width: 100%;
  min-height: ${({ $minHeight }) => $minHeight};
  height: 100%;

  padding: ${({ $padding }) => $padding || '0 20px'};
  margin-bottom: ${({ $marginBottom }) => $marginBottom || '24px'};

  > p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;

    color: #46474c;
  }
`;

interface Props {
  minHeight?: string;
  showText?: boolean;
  marginBottom?: string;
  padding?: string;
}

function ListLoadingSpinner({
  minHeight = '300px',
  showText = true,
  marginBottom,
  padding,
}: Props) {
  return (
    <LoaderContainer
      $minHeight={minHeight}
      $marginBottom={marginBottom}
      $padding={padding}
    >
      <Loading type="spinner" />

      {showText && (
        <p>
          정보를 불러오고 있어요. <br />
          잠시만 기다려 주세요.
        </p>
      )}
    </LoaderContainer>
  );
}

export default ListLoadingSpinner;
